import React from "react";

export default function EditorMainView({ step, iframeRef, iframeControlRef, previewMode = "variation" }) {
  return (
    <div className="main-view">
      {step < 3 ? (
        <iframe ref={iframeRef} title="editor" className="single-editor-frame" />
      ) : (
        <div className={`preview-stack preview-stack-${previewMode}`}>
          <iframe
            ref={iframeRef}
            title="variation"
            className={`preview-frame preview-frame-single ${
              previewMode === "variation" ? "preview-frame-active" : "preview-frame-hidden"
            }`}
          />
          <iframe
            ref={iframeControlRef}
            title="control"
            className={`preview-frame preview-frame-single ${
              previewMode === "default" ? "preview-frame-active" : "preview-frame-hidden"
            }`}
          />
        </div>
      )}
    </div>
  );
}
